export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const LANGUAGES = {
  FR: 'fr',
  AR: 'ar',
};
export const DEFAULT_LOCALE = LANGUAGES.FR;
